import { FC } from 'react';
import { Flex, HStack, Stack, Text } from '@chakra-ui/react';

import { FileDetailsFileFragment } from '../../graphql/generated';
import { DltStatus } from '../file/dlt-status/dlt-status';
import { FileStatus } from '../file-browser/file-status/file-status';
import { RefetchFileDetails } from '../file-processes/file-process-utils';
import { FileProcesses } from '../file-processes/file-processes';

type StatusesProps = {
  file: FileDetailsFileFragment;
  refetchFileDetails: RefetchFileDetails;
};

export const Statuses: FC<StatusesProps> = ({ file, refetchFileDetails }) => {
  return (
    <Stack py={8} spacing={4} w="350px">
      <Flex justify="space-between" data-testid="file-status">
        <Text color="gray.500" fontWeight="medium">
          Status
        </Text>
        <HStack>
          <FileStatus object={file} />
          <DltStatus object={file} />
        </HStack>
      </Flex>

      <FileProcesses
        fileProcesses={file.processes}
        refetchFileDetails={refetchFileDetails}
      />
    </Stack>
  );
};
